import React from "react";
import me2 from "../svgs/me2.svg";
import backgroundSvg from "../svgs/background.svg";
import backgroundSvg2 from "../svgs/blob.svg";
import backgroundSvg3 from "../svgs/whitedotted.svg";
import egg from "../svgs/egg.svg";
import ashu from "../svgs/me6.svg";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import GitHubIcon from "@material-ui/icons/GitHub";
import { useState } from "react";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ImageIcon from "@material-ui/icons/Image";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import LocalAirportIcon from '@material-ui/icons/LocalAirport';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    marginLeft: -30,
  },
}))(Tooltip);

function Main() {
  const [changeImage, setChangeImage] = useState(true);

  return (
    <div>

      <div className="flex flex-col items-center justify-center mt-10 relative " >

        {changeImage ? (
          <img src={me2} alt="" className=" h-72 " onClick={() => setChangeImage(!changeImage)} data-aos="fade-right" data-aos-delay="500"/>
        ) : (
          <div className="relative">
            <img src={ashu} alt="" className=" h-72 " onClick={() => setChangeImage(!changeImage)} data-aos="fade-right" data-aos-delay="500" />
          </div>
        )}

        <p className="text-xl sm:text-3xl " data-aos="fade-left" data-aos-delay="600">Hi, I'm Sawan Mehra</p>
        <p className="pb-2 pt-2 text-gray-400 " data-aos="fade-right" data-aos-delay="700">Full-Stack Developer</p>
        <div className="w-[90vw] sm:w-[55vw] ">
          <p className="w-[100%] text-sm sm:text-base text-center leading-6 " data-aos="fade-left" data-aos-delay="900">
            I am a professional web designer from India.Through constant
            practice & learning, I produce aesthetic software to an extremely
            high standard.
          </p>
          <LightTooltip title="Don't like image! click on it🔥 ">
            <div className="flex items-center justify-center mt-10 cursor-pointer main__imageWave">
              <LocalAirportIcon onClick={() => setChangeImage(!changeImage)} className="text-blue-500"  id="main__arrowIcon" />
            </div>
          </LightTooltip>
          <img
            src={backgroundSvg}
            alt=""
            className="h-16 opacity-50 animate-spin"
          />
          <img
            src={backgroundSvg2}
            alt=""
            className="h-32 opacity-10 absolute top-40 left-0 animate-bounce"
          />
          <img
            src={backgroundSvg2}
            alt=""
            className="h-32 opacity-10 absolute top-10 right-10 sm:right-40 animate-pulse"
          />
          <img
            src={backgroundSvg3}
            alt=""
            className="h-80 opacity-40 absolute top-80 left-20 animate-bounce"
          />
          <img
            src={egg}
            alt=""
            className="h-80 opacity-40 absolute top-40 right-0 animate-bounce hidden sm:flex"
          />
        </div>
      </div>
      <div className="  fixed top-96 left-2 sm:left-4 flex flex-col check">
        <a href="https://www.instagram.com/mehra.sawan/">
          <InstagramIcon className="mb-4 bg-[#f950ff66] p-1 rounded-lg cursor-pointer" />
        </a>
        <a href="https://www.facebook.com/sawan.mehra.520">
          <FacebookIcon className="mb-4 bg-[#6ea6ff66] p-1 rounded-lg cursor-pointer " />
        </a>
        <a href="https://github.com/ashu63">
          <GitHubIcon className="mb-4 bg-[#ffffff66] p-1 rounded-lg cursor-pointer " />
        </a>
      </div>
      <div className="flex items-center justify-center mt-12 sm:mt-16  main__arrowDown " data-aos="fade-up" data-aos-delay="1200">
        <ArrowDownwardIcon className="bg-[rgba(255,255,255,0.10)] p-1 rounded-xl" />
      </div>
      {/* <a href="mailto: ak492016@gmail.com">SEND MAIL</a> */}
      {/* <a href="./download.jpg" download="download.jpg">nfenfj</a> */}

    

    </div>
  );
}

export default Main;
